// Es6 Set supports only primitive types
function diff(requiredEntry, customEntry) {
    const required = new Set(requiredEntry);
    const custom = new Set(customEntry);
    const difference = [...required].filter((x) => !custom.has(x));
    return difference;
}

export { diff };
